import { on } from "@ngrx/store";
import { SuperUserState } from "../super-user.state";
import { QuoteSearchActions } from "./quote-search.actions";
import { PagesStore } from "../../../pages.state";

// **************************************************************************
// HELPER: Update superUser state within PagesStore
// **************************************************************************

function withSuperUser(state: PagesStore, updater: (superUser: SuperUserState) => SuperUserState): PagesStore {
    return { ...state, superUser: updater(state.superUser) };
}

// **************************************************************************
// QUOTE SEARCH REDUCER (array format for PagesStore)
// **************************************************************************

const searchQuotes = on(QuoteSearchActions.searchQuotes, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    quoteSearch: { ...superUserState.quoteSearch, loading: true },
})));

const searchQuotesSuccess = on(QuoteSearchActions.searchQuotesSuccess, (state: PagesStore, { quotes, pagination }) => withSuperUser(state, superUserState => ({
    ...superUserState,
    quoteSearch: { ...superUserState.quoteSearch, results: quotes, pagination, loading: false },
})));

const searchQuotesFailure = on(QuoteSearchActions.searchQuotesFailure, (state: PagesStore, { error }) => withSuperUser(state, superUserState => ({
    ...superUserState,
    quoteSearch: { ...superUserState.quoteSearch, loading: false },
    error,
})));

export const quoteSearchReducer = [
    searchQuotes,
    searchQuotesSuccess,
    searchQuotesFailure,
];
